import { render } from "./painelFiltroV2.vue?vue&type=template&id=984fc170&scoped=true"
import script from "./painelFiltroV2.vue?vue&type=script&lang=js"
export * from "./painelFiltroV2.vue?vue&type=script&lang=js"

import "./painelFiltroV2.vue?vue&type=style&index=0&id=984fc170&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-984fc170"]])

export default __exports__